import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { PortalHeading, Empty } from "@/pages/portal/PortalLayout";
import { InsStatus } from "./InsurerLayout";
import { insApi } from "@/lib/insurance";
import { fmtDate } from "@/lib/api";

export default function InsurerRequests() {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => { insApi.get("/requests").then((r) => setRows(r.data.requests)); }, []);
  const s = q.trim().toLowerCase();
  const list = (rows || []).filter((r) => !s || [r.claim_number, r.insured_name, r.reference, r.vehicle?.registration].some((v) => (v || "").toLowerCase().includes(s)));
  return (
    <div data-testid="insurer-requests-page">
      <PortalHeading title="My requests" sub="Every request your company has submitted"
        action={<Input placeholder="Search claim, name or reg" value={q} onChange={(e) => setQ(e.target.value)} className="sm:w-64 bg-white" data-testid="insurer-requests-search" />} />
      {rows && !list.length && <Empty testId="insurer-requests-empty">No requests yet. <Link to="/insurer/request/new" className="underline">Submit your first request</Link></Empty>}
      {list.length > 0 && (
        <div className="rounded-2xl bg-white overflow-x-auto">
          <table className="w-full text-sm" data-testid="insurer-requests-table">
            <thead className="text-left text-xs uppercase tracking-wider text-[#56585E] border-b">
              <tr><th className="p-4">Claim ref</th><th className="p-4">Insured</th><th className="p-4">Vehicle</th><th className="p-4">Submitted</th><th className="p-4">Status</th><th className="p-4" /></tr>
            </thead>
            <tbody className="divide-y">
              {list.map((r) => (
                <tr key={r.id} data-testid={`insurer-request-row-${r.reference}`}>
                  <td className="p-4 font-semibold text-[#0D141A] whitespace-nowrap">{r.claim_number}<p className="text-[11px] font-normal text-[#56585E]">{r.reference}</p></td>
                  <td className="p-4">{r.insured_name}</td>
                  <td className="p-4 whitespace-nowrap">{r.vehicle?.make} {r.vehicle?.model}<p className="text-xs text-[#56585E]">{r.vehicle?.registration}</p></td>
                  <td className="p-4 whitespace-nowrap">{fmtDate(r.created_at)}</td>
                  <td className="p-4"><InsStatus status={r.status} />{r.insurer_unread > 0 && <span className="ml-2 rounded-full bg-[#F86900] px-2 py-0.5 text-[10px] font-bold text-[#0D141A]" data-testid={`insurer-request-unread-${r.reference}`}>{r.insurer_unread} new msg</span>}</td>
                  <td className="p-4 text-right"><Link to={`/insurer/requests/${r.id}`} className="font-semibold text-[#020165] underline whitespace-nowrap" data-testid={`insurer-request-view-${r.reference}`}>View</Link></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
